// extracted by mini-css-extract-plugin
module.exports = {"resumeButton":"resume-button_resumeButton__1wD4s"};